import { Vector3 } from 'three';

import { NavMeshQuery } from '@recast-navigation/core';

const _he = new Vector3();

export type ClosestPointInNavMeshOptions = {
  distance?: number | Vector3;
};

export const closestPointInNavMesh = (
  position: Vector3,
  navMeshQuery: NavMeshQuery,
  { distance = 50 }: ClosestPointInNavMeshOptions = {}
) => {
  const result = navMeshQuery.findClosestPoint(position, {
    halfExtents:
      distance instanceof Vector3 ? _he.copy(distance) : _he.set(distance, distance, distance),
  });

  return { success: result.success, isPointOverPoly: result.isPointOverPoly, point: result.point };
};
